export default __webpack_public_path__ + "static/media/logo-white.c3e79887.png";